import React from 'react';
import { PieChart, Pie, Cell } from 'recharts';
import { PieUsageTable } from './PieUsageTable';
import { TotalUsage } from './TotalUsage';

interface UsageGraphSectionProps {
  datas: any[];
  rows: any[];
}
export const UsageGraphSection = ({
  datas, rows,
}: UsageGraphSectionProps) => (
  <div className="flex mt-20">
    <div className="mr-30 flex align-start">
      <PieChart className="mr-30" width={170} height={170}>
        <Pie
          data={datas}
          innerRadius="50"
          outerRadius="100%"
          dataKey="value"
        >
          {datas.map((data) => <Cell key={`cell-${data.header}`} fill={data.color} />)}
        </Pie>
      </PieChart>
      <PieUsageTable rows={rows} />
    </div>
    <TotalUsage />
  </div>
);
